import { getDefaultHeight, SVG } from "./utils";

type Props = {
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const InfoIcon: React.FC<Props> = ({ color, ...svgProps }) => {
  return (
    <SVG
      viewBox="0 0 6 14"
      xmlns="http://www.w3.org/2000/svg"
      height={getDefaultHeight(svgProps, 14)}
      {...svgProps}
      fill={svgProps.fill ?? "none"}
      stroke={color ?? svgProps.fill ?? "currentColor"}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path
        d="m3.96.04c.27-.07.52-.05.76.06.36.17.52.48.48.92-.01.07-.03.13-.04.18-.15.51-.48.85-1 1.02-.03 0-.05 0-.08.02-.39.11-.71.03-.98-.24-.31-.32-.34-.71-.1-1.16.19-.43.51-.69.96-.8zm-1.78 4.38c.19-.04.43-.05.72-.02.77.15 1.26.57 1.46 1.26.07.28.07.57 0 .88l-.9 2.44c-.6 1.57-.91 2.39-.92 2.46-.16.52-.17.85-.02 1 .04.03.11.04.22.04.15 0 .24 0 .28-.02.47-.16.85-.59 1.14-1.29.06-.15 1.12-.21 1.04-.01-.25.6-.57 1.11-.99 1.52-.37.35-.75.58-1.14.7-.13.03-.31.04-.54.04-.24 0-.41-.01-.52-.04-.43-.11-.75-.3-.96-.58-.16-.19-.27-.4-.32-.64-.07-.29-.07-.59 0-.9l.92-2.46c.61-1.64.94-2.54.98-2.7.05-.23.05-.43 0-.6-.07-.16-.21-.21-.44-.16-.4.08-.76.39-1.08.92-.2.33-1.22.38-1.11.14.33-.72.77-1.27 1.33-1.64.07-.04.14-.08.22-.12.24-.13.45-.21.62-.22z"
        fill="currentColor"
      />
    </SVG>
  );
};
